module.exports = __webpack_public_path__ + "static/media/tree.cd0f5b74.png";